import {
  faCaretLeft,
  faCaretRight,
  faTimesCircle,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import ReactToPrint from "react-to-print-advanced";
import {
  practitonerPrescriptionPostAction,
  prescriptionPageTabShowItemList,
  setUnfinalizedPrescriptionId,
} from "../../actions/prescriptionAction";
import RxIcon from "../../assets/images/rx-icon.png";
import {
  constructDisplayText,
  formatDate,
  formatDecimal,
  getUserDetail,
} from "../../utils/helper";
import history from "../../utils/history";
const OrderDetail = ({ closePopup, prescriptionId, date }) => {
  const dispatch = useDispatch();
  const appLoading = useSelector((state) => state.alert.appLoading);
  const componentRef = useRef();
  const [singleHerbs, setSingleHerb] = useState([]);
  const [formulaHerbs, setFormulaHerb] = useState([]);
  const [practitionerView, setPractitionerView] = useState(true);
  const [perPacket, setPerPacket] = useState(0);
  const orderedPrescription = useSelector(
    (state) => state.prescription.practitionerHistoryPresctionDetail
  );

  // useEffect(() => {
  //   dispatch(getHistoryPrescriptionForPractitioner(prescriptionId));
  // }, [dispatch]);

  const getDosage = (dosage) => {
    let value = parseFloat(dosage);
    let roundedValue =
      // orderedPrescription[0]?.Dosage_Type === 0?
      value / parseFloat(orderedPrescription[0]?.Serving_Total);
    // : value;
    return Math.round(roundedValue * 100) / 100;
  };

  const rePrescribe = () => {
    const data = {
      action: "copyPrescription",
      prescription_id: prescriptionId,
      token: getUserDetail()?.token,
    };
    var params = {
      params: data,
    };
    dispatch(
      practitonerPrescriptionPostAction(params, (id) => {
        const data = {
          action: "represcribe",
          prescription_id: id,
          token: getUserDetail()?.token,
        };
        var params = {
          params: data,
        };
        dispatch(setUnfinalizedPrescriptionId(id));
        dispatch(
          practitonerPrescriptionPostAction(params, () => {
            closePopup();
            dispatch(prescriptionPageTabShowItemList([3]));
            history.push("/app/prescription");
          })
        );
      })
    );
  };

  useEffect(() => {
    if (orderedPrescription.length > 0) {
      let singleHerbItems = [];
      let formulaHerbItems = [];
      let formulaTableData = [];
      var totalValue = 0;
      orderedPrescription[1]?.forEach((x) => {
        if (x.form_display) {
          formulaHerbItems.push(x);
        } else {
          singleHerbItems.push(x);
        }
        totalValue += getDosage(x.dosage);
      });

      setPerPacket(totalValue);
      var formulaId = 0;
      var modificationId = 0;
      for (let i = 0; i < formulaHerbItems.length; i++) {
        if (
          formulaId !== formulaHerbItems[i].form_id &&
          formulaHerbItems[i].form_id > 0
        ) {
          formulaId = formulaHerbItems[i].form_id;
          formulaTableData.push(
            <>
              <tr
                className="herb-title"
                key={formulaHerbItems[i].herb_id + "title"}
              >
                <td>{formulaHerbItems[i].form_display}</td>
              </tr>
              <tr key={formulaHerbItems[i].herb_id}>
                <td>
                  {constructDisplayText(
                    formulaHerbItems[i].herb_display,
                    formulaHerbItems[i].HERB_Latin_Name,
                    formulaHerbItems[i].HERB_Chinese_Name,
                    formulaHerbItems[i].INV_ID_Granular
                  )}
                </td>
                <td className="text-right">
                  <p
                    style={{ marginBottom: 0 }}
                    className={`${
                      formulaHerbItems[i].herb_id == 0
                        ? "sunten-formula-fix"
                        : ""
                    }`}
                  >
                    {getDosage(formulaHerbItems[i].dosage)?.toLocaleString(
                      "en-US",
                      {
                        maximumFractionDigits: 1,
                        minimumFractionDigits: 1,
                      }
                    )}
                  </p>
                </td>
              </tr>
            </>
          );
        } else {
          if (
            modificationId !== formulaHerbItems[i].mod_id &&
            formulaHerbItems[i].mod_id > 0
          ) {
            modificationId = formulaHerbItems[i].mod_id;
            formulaTableData.push(
              <>
                <tr
                  className="herb-title"
                  key={formulaHerbItems[i].herb_id + "title"}
                >
                  <td>
                    {formulaHerbItems[i].mod_display}{" "}
                    {formulaHerbItems[i].HERB_Latin_Name
                      ? `- ${formulaHerbItems[i].HERB_Latin_Name}`
                      : ""}
                  </td>
                </tr>
                <tr key={formulaHerbItems[i].herb_id}>
                  <td>
                    {formulaHerbItems[i].herb_display}{" "}
                    {formulaHerbItems[i].HERB_Latin_Name
                      ? `- ${formulaHerbItems[i].HERB_Latin_Name}`
                      : ""}
                  </td>
                  <td className="text-right">
                    {getDosage(formulaHerbItems[i].dosage).toLocaleString(
                      "en-US",
                      {
                        maximumFractionDigits: 1,
                        minimumFractionDigits: 1,
                      }
                    )}
                  </td>
                </tr>
              </>
            );
          } else {
            formulaTableData.push(
              <tr key={formulaHerbItems[i].herb_id}>
                <td>
                  {constructDisplayText(
                    formulaHerbItems[i].herb_display,
                    formulaHerbItems[i].HERB_Latin_Name,
                    formulaHerbItems[i].HERB_Chinese_Name,
                    formulaHerbItems[i].INV_ID_Granular
                  )}
                </td>
                <td className="text-right">
                  {getDosage(formulaHerbItems[i].dosage).toLocaleString(
                    "en-US",
                    {
                      maximumFractionDigits: 1,
                      minimumFractionDigits: 1,
                    }
                  )}
                </td>
              </tr>
            );
          }
        }
      }
      setSingleHerb(singleHerbItems);
      setFormulaHerb(formulaTableData);
    }
  }, [orderedPrescription]);

  return (
    <Modal size="xl" show={true} id="prescription-popup">
      <Modal.Body>
        <>
          <div className="prescription-detail">
            <div className="close-btn">
              <FontAwesomeIcon icon={faTimesCircle} onClick={closePopup} />
            </div>
            {orderedPrescription && (
              <>
                <div className="inner-section">
                  <div className="row">
                    <div className="col-md-6">
                      <p className="desc">
                        Please review your order, print or use the above tabs to
                        go back and edit the prescription.
                      </p>
                    </div>
                    <div className="col-md-6 switch">
                      <div
                        className={`swipe_content ${
                          practitionerView ? "left" : "right"
                        }`}
                      >
                        <button
                          type="button"
                          className="full_space"
                          onClick={() => setPractitionerView(!practitionerView)}
                        ></button>
                        <div className="titles">
                          <span>PRACTITIONER</span>``
                          <span>PATIENT</span>
                        </div>
                        <div className="buttons">
                          <div className="button">
                            <FontAwesomeIcon icon={faCaretLeft} />
                            VIEW
                            <FontAwesomeIcon icon={faCaretRight} />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="item-section" ref={componentRef}>
                    <div className="row">
                      <div className="col-md-8">
                        <div className="row">
                          <div className="col-md-6 reduce-height">
                            <h5>Practitioner:</h5>
                          </div>
                          <div className="col-md-6 reduce-height">
                            <p>
                              {getUserDetail()?.firstName}{" "}
                              {getUserDetail()?.lastName}
                            </p>
                          </div>
                          <div className="col-md-6 reduce-height">
                            <h5>Patient:</h5>
                          </div>
                          <div className="col-md-6 reduce-height">
                            <p>{orderedPrescription[0]?.Patient_Name}</p>
                          </div>
                          <div className="col-md-6 reduce-height">
                            <h5>Prescription #</h5>
                          </div>
                          <div className="col-md-6 reduce-height">
                            <p>{orderedPrescription[0]?.Prescription_ID}</p>
                          </div>
                          <div className="col-md-6 reduce-height">
                            <h5>Date:</h5>
                          </div>
                          <div className="col-md-6 reduce-height">
                            <p>
                              {formatDate(orderedPrescription[0]?.Created_Date)}
                            </p>
                          </div>
                        </div>
                        {practitionerView && (
                          <div className="row mt-2">
                            <div className="col-md-6 reduce-height">
                              <h5>Disease:</h5>
                            </div>
                            <div className="col-md-6 reduce-height">
                              <p>{orderedPrescription[0]?.DC_Custom}</p>
                            </div>
                            <div className="col-md-6 reduce-height">
                              <h5>Pattern:</h5>
                            </div>
                            <div className="col-md-6 reduce-height">
                              <p>{orderedPrescription[0]?.DSC_Custom}</p>
                            </div>
                            <div className="col-md-6 reduce-height">
                              <h5>Formula(s)</h5>
                            </div>
                            <div className="col-md-6 reduce-height">
                              <p>{orderedPrescription[0]?.FORM_Custom}</p>
                            </div>
                            <div className="col-md-6 reduce-height">
                              <h5>Mod(s):</h5>
                            </div>
                            <div className="col-md-6 reduce-height">
                              <p>{orderedPrescription[0]?.MOD_Custom}</p>
                            </div>
                            <div className="col-md-6 reduce-height">
                              <h5>Dosage Type:</h5>
                            </div>
                            <div className="col-md-6 reduce-height">
                              <p>
                                {orderedPrescription[0]?.Dosage_Type === 0
                                  ? "Raw"
                                  : "Granular"}
                              </p>
                            </div>
                            <div className="col-md-6 reduce-height">
                              <h5>PREPARATION METHOD:</h5>
                            </div>
                            <div className="col-md-6 reduce-height">
                              <p>
                                {orderedPrescription[0]?.prep_method_label ||
                                  orderedPrescription[0]?.Prep_Method_Name}
                              </p>
                            </div>
                          </div>
                        )}
                      </div>
                      <div className="col-md-4 icon">
                        <img src={RxIcon} alt="icon" />
                      </div>
                    </div>
                    <div className="formula-table mt-4">
                      <table className="table table_review">
                        <thead>
                          <tr>
                            <th>FORMULA(S) &amp; HERB(S)</th>
                            <th className="text-right">DOSAGE</th>
                            <th className="text-right">PRICE</th>
                          </tr>
                        </thead>
                        <tbody>
                          <>
                            {formulaHerbs.length > 0 && formulaHerbs}
                            {singleHerbs.length > 0 && (
                              <>
                                <tr className="herb-title">
                                  <td>Single Herbs</td>
                                </tr>
                                {singleHerbs.map((x) => {
                                  return (
                                    <tr key={x.herb_id}>
                                      <td>
                                        {constructDisplayText(
                                          x.herb_display,
                                          x.HERB_Latin_Name,
                                          x.HERB_Chinese_Name,
                                          x.INV_ID_Granular
                                        )}
                                      </td>
                                      <td className="text-right">
                                        {getDosage(x.dosage).toLocaleString(
                                          "en-US",
                                          {
                                            maximumFractionDigits: 1,
                                            minimumFractionDigits: 1,
                                          }
                                        )}
                                      </td>
                                    </tr>
                                  );
                                })}
                              </>
                            )}
                            {orderedPrescription[0]?.Dosage_Type === 0 &&
                              practitionerView && (
                                <>
                                  <tr>
                                    <td className="total-practitioner">
                                      Per Packet:
                                    </td>
                                    <td className="text-right">{perPacket}</td>
                                    <td className="text-right">
                                      {(
                                        orderedPrescription[0]?.Base_Price /
                                        100 /
                                        parseFloat(
                                          orderedPrescription[0]?.Serving_Total
                                        )
                                      ).toLocaleString("en-US", {
                                        maximumFractionDigits: 2,
                                        minimumFractionDigits: 2,
                                        style: "currency",
                                        currency: "USD",
                                      })}
                                    </td>
                                  </tr>

                                  <tr>
                                    <td className="total-practitioner">
                                      Number of Packets:
                                    </td>
                                    <td className="text-right">
                                      x {orderedPrescription[0]?.Serving_Total}
                                    </td>
                                    <td className="text-right">
                                      x {orderedPrescription[0]?.Serving_Total}
                                    </td>
                                  </tr>
                                  <tr className="line">
                                    <td></td>

                                    <td className="text-right">
                                      <div className="d-flex justify-content-end">
                                        <hr />
                                      </div>
                                    </td>
                                  </tr>
                                </>
                              )}
                            {practitionerView && (
                              <>
                                <tr>
                                  <td className="total-practitioner">
                                    Subtotal:
                                  </td>
                                  <td></td>
                                  <td className="text-right">
                                    <div className="d-flex justify-content-end">
                                      <p className="hr-replacement">
                                        {(
                                          orderedPrescription[0]?.Base_Price /
                                          100
                                        ).toLocaleString("en-US", {
                                          maximumFractionDigits: 2,
                                          minimumFractionDigits: 2,
                                          style: "currency",
                                          currency: "USD",
                                        })}
                                      </p>
                                    </div>
                                  </td>
                                </tr>
                                <tr>
                                  <td className="total-practitioner">
                                    Commission:
                                  </td>
                                  <td></td>
                                  <td className="text-right">
                                    {(
                                      orderedPrescription[0]?.Commission_Price /
                                      100
                                    ).toLocaleString("en-US", {
                                      maximumFractionDigits: 2,
                                      minimumFractionDigits: 2,
                                      style: "currency",
                                      currency: "USD",
                                    })}
                                  </td>
                                </tr>
                                <tr>
                                  <td className="total-practitioner">
                                    Preparation Cost:
                                  </td>
                                  <td></td>
                                  <td className="text-right">
                                    {(
                                      orderedPrescription[0]
                                        ?.Preparation_Price / 100
                                    ).toLocaleString("en-US", {
                                      maximumFractionDigits: 2,
                                      minimumFractionDigits: 2,
                                      style: "currency",
                                      currency: "USD",
                                    })}
                                  </td>
                                </tr>
                              </>
                            )}

                            <tr>
                              <td className="total-practitioner">Total:</td>
                              <td className="text-right">
                                <div className="d-flex justify-content-end">
                                  <p className="hr-replacement">
                                    {orderedPrescription[0]?.Dosage_Type === 0
                                      ? (
                                          orderedPrescription[0]
                                            ?.Serving_Total * perPacket
                                        ).toLocaleString("en-US", {
                                          maximumFractionDigits: 1,
                                          minimumFractionDigits: 1,
                                        })
                                      : orderedPrescription[0]?.Serving_Total *
                                        perPacket.toLocaleString("en-US", {
                                          maximumFractionDigits: 1,
                                          minimumFractionDigits: 1,
                                        })}
                                  </p>
                                </div>
                              </td>
                              <td className="text-right">
                                <div className="d-flex justify-content-end">
                                  <p className="hr-replacement">
                                    {(
                                      orderedPrescription[0]?.Commission_Price /
                                        100 +
                                      orderedPrescription[0]?.Base_Price / 100 +
                                      orderedPrescription[0]
                                        ?.Preparation_Price /
                                        100
                                    ).toLocaleString("en-US", {
                                      maximumFractionDigits: 2,
                                      minimumFractionDigits: 2,
                                      style: "currency",
                                      currency: "USD",
                                    })}
                                  </p>
                                </div>
                              </td>
                            </tr>
                          </>
                        </tbody>
                      </table>
                    </div>
                    <div className="serving-section">
                      {orderedPrescription[0]?.Serving_Amount == 0 ||
                      orderedPrescription[0]?.Serving_Per_Day == 0 ||
                      orderedPrescription[0]?.Serving_Days == 0 ? (
                        ""
                      ) : (
                        <>
                          <h3>Serving Instructions</h3>
                          {orderedPrescription[0]?.Dosage_Type === 0 ? (
                            <p>
                              {orderedPrescription[0]?.Serving_Per_Day}{" "}
                              packet(s) a day for{" "}
                              {orderedPrescription[0]?.Serving_Days} day(s)
                            </p>
                          ) : (
                            <p>
                              {formatDecimal(
                                orderedPrescription[0]?.Serving_Amount
                              )}{" "}
                              scoop(s),{" "}
                              {formatDecimal(
                                orderedPrescription[0]?.Serving_Per_Day
                              )}{" "}
                              times a day(s) for{" "}
                              {orderedPrescription[0]?.Serving_Days} day(s)
                            </p>
                          )}
                        </>
                      )}
                      {practitionerView && (
                        <>
                          <h3 className="mt-2">Notes on Prescription</h3>
                          <p>
                            {orderedPrescription[0]?.Patient_Instruct === ""
                              ? "None"
                              : orderedPrescription[0]?.Patient_Instruct}
                          </p>
                        </>
                      )}
                    </div>
                  </div>
                </div>
                <div className="btn-section">
                  <div className="row">
                    <div className={`col-md-10`}>
                      <ReactToPrint
                        trigger={() => (
                          <button className="btn-orange">PRINT</button>
                        )}
                        content={() => componentRef.current}
                      />
                    </div>
                    <div
                      className="col-md-2"
                      disabled={appLoading}
                      onClick={() => rePrescribe()}
                    >
                      <button className="btn-orange">Represcribe</button>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </>
      </Modal.Body>
    </Modal>
  );
};
export default OrderDetail;
